export const SIDEBAR_ITEM_HEIGHT = 44;

export const NAVBAR_WIDTH = 280;
